export default __webpack_public_path__ + "static/media/directions.3f6cc6a3.svg";